import { getRecordValue } from '../utils/record';

export type Size = keyof typeof spacing;

export const spacing = {
  xxxs: 4,
  xxs: 8,
  xs: 12,
  s: 18,
  m: 24,
  l: 36,
  xl: 48,
  xxl: 72,
} as const;

export const getSpacing = (size: Size, multiplier = 1): string => {
  return `${(getRecordValue(spacing, size) ?? 0) * multiplier}px`;
};
